/**
 * @returns {import("../datagrid").Plugin}
 */
export function localStoragePlugin(storageKey) {
  const options = localStorageOptions(storageKey);
  return { id: "localStoragePlugin", options };
}

function localStorageOptions(storageKey) {
  if (typeof storageKey === "string") {
    return {
      stateStoring: {
        enabled: true,
        type: "custom",
        customLoad() {
          return JSON.parse(localStorage.getItem(storageKey));
        },
        customSave(state) {
          // When we enable stateStoring on a DevExtreme datagrid, it keeps all filters values in the local storage, including searchbar value
          // We don't want the value entered in the searchbar to be kept in the local storage
          // This custom save implement the save of all filters except the searchbar one
          state.searchText = "";
          localStorage.setItem(storageKey, JSON.stringify(state));
        },
      },
    };
  } else {
    return {
      stateStoring: {
        enabled: false,
      },
    };
  }
}
